<mat-card style="margin: 10px;" class="mat-elevation-z1">

  <ejs-tab  cssClass="underline-customize">
    <div class="e-tab-header">
      <div><span style="color:dimgray">Manage Email List </span></div>
      <div><span style="color:dimgray">Manage Email Groups </span></div>
      <div><span style="color:dimgray">Manage Email Reply To List</span></div>
    </div>
    <div class="e-content">
      <div>
        <app-view-email-list></app-view-email-list>
      </div>
      <div>
        <app-view-email-groups></app-view-email-groups>
      </div>
      <div>
        <app-view-email-replyto-list></app-view-email-replyto-list>
      </div>
    </div>
  </ejs-tab>
</mat-card>
